import {NgModule} from '@angular/core';
import {ApparatusCardCalibrationsComponent} from './apparatus-card-calibrations.component';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '../../layout-components/layout.module';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {ApparatusCardCalibrationComponent} from './apparatus-card-calibration/apparatus-card-calibration.component';
import {CalibrationInfoComponent} from './calibration-info/calibration-info.component';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {PipesModule} from '@pipes/pipes.module';
import {IconsModule} from '@lab365/icons';


@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        FormFieldModule,
        PipesModule,
        FilesUploaderModule,
        IconsModule,
    ],
    exports: [
        ApparatusCardCalibrationsComponent,
        CalibrationInfoComponent,
    ],
    declarations: [
        ApparatusCardCalibrationsComponent,
        ApparatusCardCalibrationComponent,
        CalibrationInfoComponent,
    ],
    providers: [],
})
export class ApparatusCardCalibrationsModule {
}
